import React from "react";

import Layout from "components/Layout";
import Seo from "components/Seo";
import { graphql } from "gatsby";

import SubpageHeader from "components/SubpageHeader";
import RealizationMasonry from "components/RealizationMasonry";
import useTranslation from "locales";

import "styles/pages/page-realizations.scss";

const OurRealizationsPage = ({ pageContext, data }) => {
  const seo = pageContext.seo;
  const lang = pageContext.language?.slug;
  const allRealizations = data.allWpRealization.nodes;
  const filteredRealizationsByLang = allRealizations.filter((el) => {
    return el.language.slug === lang;
  });
  const { t } = useTranslation(lang);

  return (
    <Layout lang={lang}>
      <Seo
        title={seo.title ? seo.title : pageContext.title}
        description={seo.metaDesc}
      />
      <SubpageHeader lang={lang} title={pageContext.title} back={t("/")} />
      <section className="section-our-realizations">
        <div className="container">
          <div className="row">
            <RealizationMasonry options={filteredRealizationsByLang} />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query {
    allWpRealization(sort: { order: DESC, fields: date }) {
      nodes {
        language {
          slug
        }
        portfolioAcf {
          city
          mainImg {
            sourceUrl
          }
          year
          logo {
            sourceUrl
          }
        }
        slug
        title
        uri
      }
    }
  }
`;

export default OurRealizationsPage;
